
import boiler from '../assets/boiler.jpg';

import port from '../assets/port-stay.jpg';

import motor from '../assets/motor-rewinding.jpg';

import tank from '../assets/tank-level.jpg';

import fridge from '../assets/fridge-service.jpg';

import ccp from '../assets/cpp.jpg';

import accumulator from '../assets/accumulator.jpg';

import generator from '../assets/generator-sync.jpg';

import overhaul from '../assets/ge-overhaul.jpg';

import hatch from '../assets/hatch.jpg';

import steel from '../assets/steel.jpg';

import cooler from '../assets/cooler.jpg';


import OME from '../assets/OME.jpg';
import RORO from '../assets/RORO.jpg';
import pump from '../assets/pump&motor.jpeg';
import seawater from '../assets/seawater.jpeg';
import hamabanthota from '../assets/hambanthota.jpeg'
import Workdone1 from '../assets/Workdone1.webp';
import WorkDone_1 from '../assets/Work Done_1.webp';
import workdone1 from '../assets/work_done_1.webp';
import MVFLAX from '../assets/mvflax3.webp';
import AR from '../assets/AR-engine.webp';
import WN from '../assets/w2.webp';
import mx from '../assets/mx-4.webp';
import newAm from '../assets/new Am1.webp';
import MTISE from '../assets/MT-ISE.webp';
import set from '../assets/set.webp';
import HullPaint from '../assets/Hull painting.webp';
import Cleaning from '../assets/cleaning4.webp';
import Cooler from '../assets/cool new.webp';
import W1 from '../assets/W11.webp';
import Scub from '../assets/suber.webp';
import wda5 from '../assets/wda5.webp';

const projects = [

  {
    id: "pms-control-circuit",
    title: "PMS and BT Controls Circuit Troubleshooting",
    description: "We performed in-depth diagnostics and repairs on the Power Management System and Bow Thruster control circuits to restore seamless operation and safety compliance.",
    mainImages: require("../assets/pms.jpg"),
    additionalImages: [
      require("../assets/pms1.jpg"),
      require("../assets/pms2.jpg"),
      require("../assets/pms3.jpg"),
      require("../assets/pms4.jpg"),
      require("../assets/pms5.jpg"),

    ],
  },
  {
    id: "boiler-health-check",
    title: "Boiler Health Check",
    description: "Our expert team conducted a thorough boiler health check to identify inefficiencies, leaks and performance issues.",
    mainImages: [boiler],
    additionalImages: [
      require("../assets/boiler1.jpg"),
      require("../assets/boiler2.jpg"),
      require("../assets/boiler3.jpg"),
      require("../assets/boiler4.jpg"),
      require("../assets/boiler5.jpg"),
    ],
  },
  {
    id: "port-stay-repairs",
    title: "How You Utilize Your Port Stay for Emergency Repairs",
    description: "We optimized short port stays to perform emergency mechanical, electrical and structural repairs.",
    mainImages: [port],
    additionalImages: [
      require("../assets/port1.jpg"),
      require("../assets/port2.jpg"),
      require("../assets/port3.jpg"),
      require("../assets/port4.jpg"),

    ],
  },
  {
    id: "motor-rewinding",
    title: "Motor Rewinding",
    description: "Dry Ice Cleaning Complete motors and precision rewarding of marine motors with high-performance instulation materials",
    mainImages: [motor],
    additionalImages: [
      require("../assets/motor1.jpg"),
      require("../assets/motor2.jpg"),
      require("../assets/motor3.jpg"),
      require("../assets/motor4.jpg"),
      require("../assets/motor5.jpg"),


    ],
  },
  {
    id: "tank-level-calibration",
    title: "Tank Level Gauging System Calibration",
    description: "Calibrated the tank level measurement systems to ensure accurate readings.",
    mainImages: [tank],
    additionalImages: [
      require("../assets/tank1.jpg"),
      require("../assets/tank2.jpg"),
      require("../assets/tank3.jpg"),
      require("../assets/tank4.jpg"),
      require("../assets/tank5.jpg"),
      require("../assets/tank6.jpg"),

    ],
  },
  {
    id: "domestic-refrigeration",
    title: "Domestic Refrigeration System Servicing",
    description: "Servicing of domestic refrigeration units aboard vessels to maintain optimal cooling.",
    mainImages: [fridge],
    additionalImages: [
      require("../assets/fridge1.jpg"),
      require("../assets/fridge2.jpg"),
      require("../assets/fridge3.jpg"),
      require("../assets/fridge4.jpg"),

    ],
  },
  {
    id: "cpp-troubleshooting",
    title: "Ships CPP Automation Troubleshooting",
    description: "Diagnosed and repaired issues in the CPP automation system to restore precision control.",
    mainImages: [ccp],
    additionalImages: [
      require("../assets/ccp1.jpg"),
      require("../assets/ccp2.jpg"),
      require("../assets/ccp3.jpg"),
      require("../assets/ccp4.jpg"),
      require("../assets/ccp5.jpg"),
    ],
  },
  {
    id: "afloat-repairs",
    title: "Afloat Repairs",
    description: "Comprehensive afloat repair services including structural, mechanical and electrical work.",
    mainImages: require("../assets/afloat.jpg"),
    additionalImages: [
      require("../assets/aflot7.jpeg"),
      require("../assets/aflot8.jpeg"),
      require("../assets/aflot4.jpg.png"),
      require("../assets/aflot5.jpg.png"),
      require('../assets/aflot6.jpg.png'),
    ],
  },
  {
    id: "accumulator-recharge",
    title: "Re-Charging of Accumulators",
    description: "Performed safe and effective re-charging of shipboard accumulators.",
    mainImages: [accumulator],
    additionalImages: [
      require("../assets/accumulator1.jpg"),
      require("../assets/accumulator2.jpg"),
      require("../assets/accumulator3.jpg"),
      require("../assets/accumulator4.jpg"),
    ],
  },
  {
    id: "pipe-fabrication",
    title: "Pipe Line Fabrication",
    description: "Engineered and installed custom pipelines with corrosion-resistant materials.",
    mainImages: require('../assets/pipe-fabrication.jpg'),
    additionalImages: [
      require('../assets/pipe1.jpg'),
      require('../assets/pipe2.jpg'),
      require('../assets/pipe3.jpg'),
      require('../assets/pipe4.jpg'),

    ],
  },
  {
    id: "generator-sync",
    title: "Generator Engine Synchronizing Issue Troubleshooting",
    description: "Restored proper synchronization between generators to prevent blackout conditions.",
    mainImages: [generator],
    additionalImages: [
      require('../assets/generator1.jpg'),
      require('../assets/generator2.jpg'),
      require('../assets/generator3.jpg'),
      require('../assets/generator4.jpg'),
    ],
  },
  {
    id: "ge-overhaul",
    title: "Overhaul of Generator Engine",
    description: "Complete overhaul of Generator Engine including inspection and testing.",
    mainImages: [overhaul],
    additionalImages: [
      require("../assets/overhaul1.jpg"),
      require("../assets/overhaul2.jpg"),
      require("../assets/overhaul3.jpg"),
      require("../assets/overhaul5.jpg")
    ],
  },
  {
    id: "hatch-repair",
    title: "Hatch Repair Work",
    description: "Repaired and reinforced cargo hatch covers for watertight integrity.",
    mainImages: [hatch],
    additionalImages: [
      require("../assets/hatch1.jpg"),
      require("../assets/hatch2.jpg"),
      require("../assets/hatch3.jpg"),
    ],
  },
  {
    id: "misc-steel-work",
    title: "Miscellaneous Steel Work",
    description: "Steel fabrication including brackets, supports and platform reinforcement.",
    mainImages: [steel],
    additionalImages: [
      require("../assets/steel1.jpg"),
      require("../assets/steel2.jpg"),
      require("../assets/steel3.jpg"),
      require('../assets/steel4.jpg'),
      require("../assets/steel5.jpg"),
      require("../assets/steel6.jpg"),

    ],
  },
  {
    id: "cooler-cleaning",
    title: "LT Cooler Cleaning",
    description: "Deep cleaning of low-temperature coolers to restore thermal efficiency.",
    mainImages: [cooler],
    additionalImages: [
      require("../assets/cooler1.jpg"),
      require("../assets/cooler2.jpg"),
      require("../assets/cooler3.jpg"),
      require("../assets/cooler4.jpg"),
    ],
  },
  {
    id: "22",
    title: 'Crane No. 2 Jib Sheave Replacement',
    project: "Team CIAP successfully executed the Crane No. 2 jib sheave replacement onboard MV LXXX FRXXXX, demonstrating our commitment to safety, precision and operational excellence.",
    description: [
      "The project scope included a thorough inspection of the crane to assess wear and alignment issues, safe removal of the old jib sheave, and precise installation of the new sheave to ensure smooth crane boom operation.",
      "Following installation, the “Team CIAP’ conducted comprehensive operational testing, verifying rotation, load-bearing capacity and overall functionality. Every step was carried out in strict compliance with safety protocols and industry best practices, ensuring zero incidents throughout the project.",
      "Team CIAP is always committed to supporting technical expertise, meticulous planning, and collaborative effort for the successful completion of the assignments to minimize lost time and run the vessel.",
      "We are just one click away—ready to deliver reliable “ Total Marine Engineering Solutions” with precision, safety and efficiency. ⚓✨",
    ],
    vessel: "MV LXXX FRXXXX ",
    location: "Port of Colombo, Sri Lanka.",
    completed: true,
    mainImages: [wda5],
    additionalImages: [
      require('../assets/wda1.webp'),
      require('../assets/wda2.webp'),
      require('../assets/wda3.webp'),
      require('../assets/wda4.webp'),
      require('../assets/wda5.webp'),


    ],
    link: " https://www.facebook.com/share/p/1Ao4YCmt2L/"
  },
  {
    id: "21",
    title: ['Scrubber Overboard Stub Pipe Section Repair.',
      ' In today’s Maritime Operations, time = cost.',
      ' And often, the biggest savings come not just from operations—but from Efficient Execution of Critical Repairs.'],
    project: "Onboard MV Mxxx Exxx at Port of Colombo, a damaged Scrubber Overboard Pipe Stub Section required urgent repair, with:",
    description: [
      "T• Limited port stay",
      '• Critical system dependency',
      '• Strict safety and quality requirements',
      'Traditional Approach?',
      '➡Delay repair',
      '➡Extend port stay',
      '➡Risk operational downtime',
      '👉Proper Blanking carried out by CIAP partnered diving company and confirmed proper water tightness',
      'Estimated Impact:',
      '• Increased vessel downtime',
      '• Additional port and operational costs',
      '• Schedule disruption',
      'The CIAP Approach',
      'Instead of delays, Team CIAP executed the repair efficiently within the available port window.',
      'Immediate attendance, onboard inspection and damage assessment',
      'Proper Blanking carried out by CIAP partnered diving company and confirmed proper water tightness',
      'Controlled removal of the defective stub pipe section',
      'Fabrication of new pipe section as per specifications',
      'Proper surface preparation',
      'Precision alignment and certified welding as per the approved welding procedure',
      'NDT inspection and leak testing to ensure integrity',
      'Scope Included:',
      'Inspection and defect identification',
      '✔Proper blanking ',
      '✔Cutting and removal of damaged section',
      '✔Fabrication and fit-up of new stub pipe',
      '✔High-quality welding and finishing',
      '✔Testing and quality assurance      ',
      'The Result',
      'The repair was successfully completed on time, ensuring:',
      '• Zero additional downtime',
      '• Full operational reliability of the scrubber system',
      '• Compliance with marine safety and quality standards',
    ],
    vessel: "MV Mxxx Exxx",
    location: "Port of Colombo, Sri Lanka.",
    completed: true,
    mainImages: [Scub],
    additionalImages: [
      require('../assets/scubber4.webp'),
      require('../assets/sub3.webp'),
      require('../assets/su5.webp'),
      require('../assets/scubber2.webp'),


    ],
    link: "  https://www.facebook.com/share/p/16oobtmKAU/"
  },
  {
    id: "20",
    title: 'The Repair of a Damaged Weathertight Door',
    project: "The scope of work commenced with a comprehensive technical inspection and damage assessment of the weathertight door assembly, including the door frame, adjacent bulkhead structure, dogging arrangement, hinges and rubber sealing gasket.",
    description: [
      "The assessment identified significant structural damage to the adjacent bulkhead plating as well as deterioration of the sealing arrangement, which had the potential to compromise the weathertight integrity and proper functioning of the door assembly.",
      "Following the inspection, the team carried out the required rectification work, which included structural reinforcement and repair of the damaged bulkhead plating, realignment of the door structure and servicing and adjustment of the hinge and dogging/locking mechanisms to restore proper operational functionality. Additionally, the sealing gasket was replaced and adjusted to achieve the required uniform compression, ensuring an effective watertight sealing arrangement. The door frame and mating contact surfaces were mechanically cleaned and properly prepared to ensure correct seating of the gasket and optimal sealing performance.",
      "Upon completion of the repair works, operational tests and sealing integrity checks were carried out to verify the smooth operation of the door mechanism, proper engagement of the dogging system, and adequate compression of the sealing gasket.",
      "All functional tests confirmed that the door assembly had been successfully restored to the required weathertight condition in compliance with applicable marine safety and operational standards.",
      "Total Marine Engineering Solutions – Delivered with Safety, Precision and Reliability.",
    ],
    vessel: "MV ZXXX 80 ",
    location: "Port of Colombo, Sri Lanka.",
    completed: true,
    mainImages: [W1],
    additionalImages: [
      require('../assets/W2 copy.webp'),
      require('../assets/W3.webp'),


    ],
    link: "  https://www.linkedin.com/feed/update/urn:li:activity:7442792007170867200"
  },
  {
    id: "19",
    title: '“Team CIAP” successfully completed the Dismantling, Cleaning, Inspection and Reinstallation of an Auxiliary Engine Air Cooler onboard the vessel',
    project: "The scope of work included a Detailed Inspection, Controlled Dismantling and Thorough Cleaning of the Air Cooler Unit to remove accumulated Oil Residues, Carbon Deposits, and Dust, which can Adversely Affect Heat Transfer Efficiency And Airflow Across the Cooler Elements.",
    description: [
      "Our technical team carried out Mechanical Cleaning Followed By Chemical Washing Procedures to effectively remove contaminants from the cooler tubes and fins. This process was followed by Freshwater Flushing to Eliminate Chemical Residues and Ensure Internal Cleanliness, after which the Cooler Elements Were Properly Dried to Prevent Corrosion and Moisture Retention.",

      "Upon completion of the cleaning process, the air cooler assembly was Carefully Reinstalled, Properly Aligned and Securely Fastened. The system was subsequently tested to Verify Proper Operation and Ensure Leak-Free Performance.",

      "This maintenance activity helps to Restore Optimal Heat Transfer Efficiency, Improve Charge Air Cooling to the Engine and Support Stable And Efficient Engine Operation.",
    ],
    vessel: "MSC PXXXX  ",
    location: "Port of Colombo, Sri Lanka.",
    completed: true,
    mainImages: [Cooler],
    additionalImages: [
      require('../assets/COOL 2.webp'),
      require('../assets/COOLR 3.webp'),
      require('../assets/COOLR 4.webp'),
      require('../assets/COOR 5.webp'),

    ],
    link: "  https://www.linkedin.com/feed/update/urn:li:activity:7439623596920025088"
  },
  {
    id: "18",
    title: 'The “Team CIAP” successfully completed the Cleaning and Restoration of the Atmospheric Dump Condenser onboard',
    project: "The Condenser was systematically isolated from the system, depressurized and fully drained in accordance with onboard safety procedures. ",
    description: [
      "Both end covers were removed to enable internal inspection, which confirmed significant fouling and choking across the inlet and outlet tube banks.",
      "Comprehensive tube cleaning was conducted to remove scale, deposits and obstructions, ensuring restoration of design flow characteristics and heat exchange efficiency. Upon completion of cleaning, the condenser was reassembled, aligned, and reinstated into the system. A pressure integrity test was conducted and verified satisfactory, confirming system readiness for operational service.",

      "The equipment was subsequently handed over to the vessel’s engineering team in fully functional condition, meeting operational and safety requirements.",

      "'Team CIAP' continues to deliver precision-driven 'Total Marine Engineering Solutions', supporting vessel reliability and performance across Global Ports.",
    ],
    vessel: "MV MSC SUBXXX XXX  ",
    location: "Port of Colombo, Sri Lanka.",
    completed: true,
    mainImages: [Cleaning],
    additionalImages: [
      require('../assets/cleaning1.webp'),
      require('../assets/cleaning2.webp'),
      require('../assets/cleaning3.webp'),

    ],
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7433470371305238528"
  },
  {
    id: "17",
    title: '“Team CIAP", successfully completed the starboard-side touch-up hull painting onboard',
    project: "The work commenced with a comprehensive inspection of the designated Hull areas to assess coating degradation, corrosion spread and surface contamination.",
    description: [
      "All affected areas were de-rusted using approved tools to remove loose paint, rust scale, ensuring the surface met the required preparation standards. Following cleaning, the prepared surfaces were properly feathered, degreased, and conditioned to achieve optimal adhesion. A compatible Marine-Grade Protective Coating System was subsequently applied in controlled layers, maintaining the specified dry film thickness and observing manufacturer-recommended recoat and curing intervals. Application was closely monitored to ensure uniform coverage, proper bonding and long-term resistance against seawater exposure and operational wear. All work was carried out under strict safety and environmental controls in accordance with Marine Maintenance Procedures.",
    ],
    vessel: "MV CMA CGM MENDXXXXXXX ",
    location: "Port of Colombo, Sri Lanka.",
    completed: true,
    mainImages: [HullPaint],
    additionalImages: [
      require('../assets/hu1.webp'),
      require('../assets/hu2.webp'),
      require('../assets/hu5.webp'),
      require('../assets/hu4.webp'),


    ],
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7433470371305238528"
  },
  {
    id: "16",
    title: '"Team CIAP” successfully completed the replacement and installation of the satellite antenna onboard MV MSC JAMXXXX IX at the Port of Colombo"',
    project: "The scope of work included the safe dismantling of the existing antenna assembly from the monkey island mounting pedestal using certified access scaffolding and electrical isolation procedures.",
    description: [
      "The new satellite antenna was carefully rigged and hoisted from the main deck to the installation location using controlled lifting arrangements and tag lines to prevent mechanical damage and uncontrolled movement.",
      "The unit was precisely positioned, aligned with the vessel’s reference line and securely fastened to the existing mounting structure using appropriate grade fasteners. Final leveling, mechanical securing and verification checks were carried out in accordance with the manufacturer’s installation manual and applicable Marine Engineering practices to ensure optimal operational performance and signal stability. ",
    ],
    vessel: "MV MSC JAMXXXX IX ",
    location: "Port of Colombo, Sri Lanka.",
    completed: true,
    mainImages: [set],
    additionalImages: [
      require('../assets/set2.webp'),
      require('../assets/set4.webp'),
      require('../assets/set5.webp'),


    ],
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7430083740128772096"
  },
  {
    id: "15",
    title: "“Team CIAP” Engineering Excellence, Ship Repair",
    project: " Cargo Hold No. 01 – Void Space",
    description: [
      ' "Team CIAP" successfully completed the structural renewal of the punched bottom plating located within the void space beneath Cargo Hold No. 01 onboard MT ISEXXX KOXX at the Port of Galle, restoring the vessel’s hull integrity in full compliance with approved class and marine repair standards. The work commenced with a comprehensive inspection and damage assessment, followed by cropping of the affected steel plate section within class-approved limits. A replacement insert plate was fabricated from certified marine-grade steel material and accurately fitted in situ between Frame Nos. 128, 129, and 130, ensuring correct alignment and structural continuity. Welding operations were carried out strictly in accordance with approved Welding Procedure Specifications (WPS) by class-qualified welders, achieving full penetration welds and required mechanical strength. Upon completion, all welded joints were subjected to non-destructive testing (NDT) to verify weld quality and structural soundness. Final surface preparation and application of approved anti-corrosion protective coatings were carried out to ensure long-term durability and watertight performance. The repair was successfully completed under strict safety, quality and schedule controls, minimising vessel downtime and ensuring continued seaworthiness and operational reliability.',
      'Contact Us for Marine & Engineering Support – Onshore or Offshore',
    ],
    vessel: "MT ISEXXX KOXX",
    location: "Port of Galle, Sri Lanka.",
    completed: true,
    mainImages: [MTISE],
    additionalImages: [
      require('../assets/MT-ISE1.webp'),
      require('../assets/MT-ISE2.webp'),
      require('../assets/MT-ISE3.webp'),
      require('../assets/MT_ISE4.webp'),

    ],
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7429359573297283072"
  },

  {
    id: "14",
    title: "“Team CIAP” travelled more than 180nm to assist a vessel in distress.",
    project: "Colombo, January 2026 – A distressed bulk carrier vessel was successfully restored to power and safely navigated back to Colombo OPL by the CIAP Engineering team",
    description: [
      "The vessel had been drifting away from Sri Lanka, carrying a high risk of collision and grounding, due to multiple technical failures. With the crew facing mounting uncertainty and critically low levels of marine diesel oil and fresh water, urgent assistance was requested by the ship management company On 11 January 2026, the CIAP Engineering Team boarded the vessel after a challenging 22-hour boat journey through extreme sea conditions. Once onboard, the engineers carried out critical repairs to the ship’s boiler and generators, restoring essential power and stabilizing operations. Their intervention prevented further deterioration of the situation and ensured the safety of both the crew and the vessel.Following the successful repairs, the vessel was escorted to the Outer Port Limit Anchorage (OPL) of Colombo, where it underwent further operational checks and replenishment.Ship Management commended the CIAP Engineering Team for their professionalism and resilience. “This rescue highlights the importance of technical expertise and determination in safeguarding maritime operations,” he further stated. “The team’s efforts not only saved the vessel but also protected valuable cargo and ensured the well-being of its crew.” After bunkering and resupply arrangements were completed, the restored bulk carrier departed the anchorage to continue her voyage.",
      "💙 Proud of “Team CIAP” for their unwavering dedication and commitment to Maritime Safety ",
    ],
    vessel: "MV MSC AQXXXXX XX",
    location: "Port of Colombo, Sri Lanka.",
    completed: true,
    mainImages: [newAm],
    additionalImages: [
      require('../assets/am2.webp'),
      require('../assets/am4.webp'),
      require('../assets/am5.webp'),
      require('../assets/am9.webp'),

    ],
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7425486095083298817"
  },
  {
    id: "13",
    title: "“Team CIAP” successfully completed the Major Overhaul of Diesel Generator Engine No. 02",
    project: " the project in full compliance with OEM specifications, class requirements, and international marine engineering standards",
    description: [
      "The overhaul commenced with a comprehensive condition assessment, operational analysis, and fault diagnostics to identify performance deviations and assess the extent of mechanical wear. This was followed by complete dismantling of the engine, during which all critical components were systematically removed, cleaned, and subjected to detailed visual and dimensional inspections using precision measuring instruments. Worn, damaged, and out-of-tolerance parts were renewed in accordance with manufacturer recommendations, while key components such as the crankshaft, main and connecting rod bearings, pistons, cylinder liners, connecting rods, and valve mechanisms were thoroughly examined. The fuel injection system, including fuel pumps and injectors, was dismantled, overhauled, calibrated, and tested to ensure accurate fuel delivery and optimal combustion. In parallel, the lubrication and cooling systems were inspected, flushed, overhauled, and restored to ensure efficient thermal control and reliable lubrication under all operating conditions.Reassembly was carried out with strict adherence to OEM-specified tolerances, torque settings, and clearances, followed by comprehensive safety checks. Upon completion, the engine was subjected to trial runs under controlled conditions to validate performance parameters such as stability, vibration levels, temperature profiles, and power output. The successful completion of these activities resulted in the restoration of engine performance to optimal operational standards, enhanced reliability and safety, and significant reduction in vessel downtime, reaffirming CIAP’s capability in delivering high-quality Total Marine & Engineering Solutions for critical onboard machinery."

    ],
    vessel: "MV MSC AQXXXXX XX",
    location: "Port of Hambantota, Sri Lanka.",
    completed: true,
    mainImages: [mx],
    additionalImages: [
      require('../assets/mx-2.webp'),
      require('../assets/mx-3.webp'),
      require('../assets/mx-1.webp'),
      require('../assets/mx-5.webp'),
      require('../assets/mx-6.webp'),
      require('../assets/mx-7.webp')
    ],
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7419324874625732608"
  },
  {
    id: "12",
    title: "Fabrication &  Installation  of Main Engine Air Starting Line Drain Pipe Section Completed",
    project: "Complete fabrication and Installation of the drain pipe section of the Main Engine Air Starting Line",
    description: [
      "The “Team CIAP” successfully completed the Fabrication and Installation of the drainpipe section of the Main Engine Air Starting Line in accordance with Marine Engineering standards and vessel requirements. The scope of work included the accurate fabrication, fit-up and welding of the designated pipeline section, ensuring correct alignment, with all safety precautions strictly implemented throughout the operation. During inspection, a new crack was identified on a welded area, which was promptly rectified by CIAP specialists through controlled removal of the affected weld, re-welding in accordance with approved welding procedures and local structural reinforcement to restore full mechanical strength. Following these repairs, the pipeline underwent comprehensive pressure testing to verify performance under operating conditions, during which no evidence of leakage, deformation or structural weakness was observed, confirming system reliability. All tasks were executed in compliance with established Marine Engineering and quality assurance standards and the project was completed efficiently, minimizing operational downtime and ensuring the Main Engine Air Starting Line remains fully prepared for service."

    ],
    vessel: "MV MSC SHXX",
    location: "Port of Hambantota, Sri Lanka.",
    completed: true,
    mainImages: [WN],
    additionalImages: [
      require('../assets/W N.webp'),
      require('../assets/W3JAN.webp'),
      require('../assets/W4JAN.webp'),
      require('../assets/w5JAN.webp'),
    ],
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7419324874625732608"
  },
  {
    id: "11",
    title: "AE3 Paralleling Issue – Troubleshooting Completed",
    project: "Complete Troubleshooting AE3 Paralleling Issue",
    description: [
      "1. Initial Inspection of No.3 Generator AVR.",
      "• The team inspected the Automatic Voltage Regulator (AVR) of No.3 Generator.",
      "• The AVR was identified as faulty.",
      "• Incorrect wiring connections were also found.",
      "• The wiring was corrected.",
      "• Detailed Reporting & Recommendations",
      "2. Assessment of No.2 Generator AVR:",
      "•  Ship staff informed the team that No.2 Generator was also unable to operate due to mechanical issues.",
      "•  With the Chief Engineer’s approval, the team proceeded to swap the AVR from No.2 Generator to No.3 Generator.",
      "3. AVR Swap & Final Testing",
      "•  The AVR was successfully exchanged and adjusted.",
      "•  Functional tests were carried out and fine tuning was done successfully.",
      "•  Post-testing, the performance of No.3 Generator was found to be satisfactory, and the paralleling issue was resolved.",
      "The troubleshooting work was completed in line with the job scope, and the system was formally handed over to the ship’s engineering staff.",
      "CIAP – Powering Reliable Automation Through Expert Engineering."

    ],
    vessel: "MV MSC KXXXX II",
    location: "Port of Colombo , Sri Lanka",
    completed: true,
    mainImages: [AR],
    additionalImages: [
      require('../assets/AR-engine2.webp'),
      require('../assets/AR-engine3.webp'),
      require('../assets/AR-engine1.webp'),
    ],
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7415631255364448256"
  },

  {
    id: "10",
    title: "Analog Input Module Troubleshooting",
    project: "Complete Troubleshooting Analog Input Module. Our Service experts carried out Analog Input Module Troubleshooting, ensuring accurate signal processing, system reliability, and seamless communication across the automation network.",
    description: [
      "Our service scope covers complete fault diagnosis and recovery of Analog input Modules used in PLC, DCS and SCADA systems.",
      "• Inspection Of Wiring, Connections & Power Supply",
      "• Signal Testing and Calibration (4–20ma / 0–10V)",
      "• Identification Of Noise, Drift Or Faulty Channels",
      "• Module Repair, Replacement & Reconfiguration",
      "• Detailed Reporting & Recommendations",
      "We ensure your automation systems deliver accurate and reliable data — minimizing downtime and improving operational efficiency. “Team CIAP” , our skilled Engineers specialize in:",
      "•  Diagnosing Signal Irregularities and Voltage Fluctuations",
      "•  Testing and Calibrating Sensors and Transmitters",
      "•  Restoring Accurate Communication Between Field Instruments and Control Units",
      "•  Implementing Preventive Maintenance to Reduce Future Downtime",
      "We ensure precise data integrity, stable operations and extended equipment life across Marine and Industrial Applications."

    ],
    vessel: "MV FALXXX XXX",
    location: "Port of Hambantota, Sri Lanka.",
    completed: true,
    mainImages: [MVFLAX],
    additionalImages: [
      require('../assets/mvflax2.webp'),
      require('../assets/mvflax1.webp'),
      require('../assets/mvflax.webp'),
    ],
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7398549516465049600"
  },
  {
    id: "9",
    title: " Emergency Generator Auto-Starting",
    project: " Our Expert “Team CIAP” successfully completed comprehensive troubleshooting on the vessel’s Emergency Generator Auto-Onload system, restoring full operational efficiency while ensuring reliability and compliance with international maritime standards.",
    description: [

      "• Our Expert Engineers carried out a full inspection and health check of the Emergency Switchboard Panel – Generator All safety interlocks were verified, and the root cause was identified as a faulty standby interlock contactor.",
      "• Conducted complete panel inspection",
      "• Identified malfunctioning interlock contactor",
      "• Replaced defective unit with onboard spare",
      "• Performed system testing and multiple operational trials.",
      "Following the replacement, the Emergency Generator successfully started and took the load automatically. The system was thoroughly tested and handed over to the ship’s staff in fully operational condition. Team CIAP—Ensuring reliability, safety & uninterrupted vessel operations"
    ],
    vessel: "MV MSC XXXX",
    location: "Port of Colombo, Sri Lanka",
    completed: true,
    mainImages: [workdone1],
    additionalImages: [
      require('../assets/work_done_3.webp'),
      require('../assets/work_done_2.webp'),
      require('../assets/work_done_5.webp'),
    ],
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7398549516465049600"
  },
  {
    id: "8",
    title: "Ballast Water Treatment System Troubleshooting",
    project: "Complete Troubleshooting and Rectification of Ballast Water Treatment System",
    description: [
      "Our expert Team CIAP successfully completed comprehensive troubleshooting and rectification of the vessel’s Ballast Water Treatment System (BWTS), ensuring restored operational efficiency and compliance with international environmental regulations.",
      "• Inspected critical BWTS components including Control & Monitoring Units, Flow and Pressure Sensors, UV Reactor Modules, Chemical Dosing Systems, and Safety Interlocks.",
      "• Identified and corrected signal inconsistencies in sensor feedback loops.",
      "• Verified PLC logic and communication across control modules.",
      "• Rectified actuator control faults and recalibrated all key sensors.",
      "• Conducted complete system functionality and safety testing to ensure reliable automated operation."
    ],
    vessel: "MV MSC SilXXX XX",
    location: "Port of Colombo, Sri Lanka",
    completed: true,
    mainImages: [WorkDone_1],
    additionalImages: [
      require('../assets/workdone_3.webp'),
      require('../assets/workdone_2.webp'),
      require('../assets/workdone_4.webp'),
      require('../assets/workdone_5.webp'),
    ],
    link: ": https://www.linkedin.com/feed/update/urn:li:activity:7396033766298681344"
  },
  {
    id: "7",
    title: "Steel Renewal in Web Frame 3X & 4X",
    project: "Section Repair as per the Class Requirement.",
    description: [
      'Our skilled "Team CIAP" successfully completed steel renewal works in Web Frames 3X & 4X, restoring the vessel\'s structural integrity and ensuring compliance with Marine class standards.',
      " • Steel Plates Were Marked According to the Drawings Provided",
      " • Both 3X and 4X Web Frame Steel Plate Pieces Were Fabricated According to the Marked Dimensions",
      " • Existing Web Frame Openings Were Resized According to Fabricated Plate Dimensions",
      " • Surface Preparation Done on Both 3X and 4X Web Frames Including Inserting Ones",
      " • Steel Plate Joining Process Was Carried Out Using GMAW"
    ],
    vessel: "",
    location: "Port of Colombo, Sri Lanka",
    completed: true,
    mainImages: [Workdone1],
    additionalImages: [
      require('../assets/Workdone3.webp'),
      require('../assets/Workdone2.webp'),
      require('../assets/Workdone4.webp'),
      require('../assets/Workdone5.webp'),
    ],
    link: " https://www.linkedin.com/feed/update/urn:li:activity:7394338764619304960"
  },

  {
    id: "6",
    title: "“Team CIAP”, successfully carried out a Hull Repair on board one of our client vessel, which supported with hanging staging out board.",
    project: "This task Supported with CIAP Operation and Technical Team Planning, Safety Protocols and Close Coordination with the Vessel Crew.",
    description: ["Despite demanding conditions",
      "• our team worked tirelessly 24/7, ensuring the project was completed safely and on schedule.",
      "• This is another successful assignment which completes on time reflecting 'Team CIAP'’s strength in delivering reliable, ",
      "• high-quality solutions for ship repair and maintenance in the region. We take pride in our ability to execute complex repairs efficiently, even in challenging environments. ",

    ],
    vessel: "",
    location: "Hambantota, Sea Port, Sri Lanka",
    completed: true,
    mainImages: [hamabanthota],
    additionalImages: [
      require('../assets/hambanthota1.jpeg'),
      require('../assets/hambanthota (don).jpeg'),


    ],
    Link: "https://www.facebook.com/share/p/19rsLvUo2d/",

  },
  {
    id: " 5",
    title: "Control Circuit of Main Step-Down Transformer – Troubleshooting",
    description: 'Our Expertise "Team CIAP " carried out detailed troubleshooting of the control circuit of the main step-down transformer, ensuring reliable power distribution and uninterrupted operations. Through systematic diagnostics and corrective action, we restored performance and enhanced system safety.',
    mainImages: require("../assets/cc.jpeg"),
    completed: true,
    Link: "https://www.facebook.com/share/p/1E9MN8bpc9/",
    additionalImages: [
      require("../assets/cc1.jpeg"),
      require("../assets/cc2.jpeg"),
      require("../assets/cc3.jpeg"),


    ],
  },
  {
    id: " 1",
    title: "A scope generally executed by OEM",
    project: "Main Engine cylinder head removal, changing of the cylinder jacket and installation of the vessel’s spare complete cylinder head assembly due to heavy cooling water leakage to perform in short port stay.",
    description: "Complete Main Engine cylinder head removal, changing of the cylinder jacket and installation of the vessel’s spare complete cylinder head assembly",
    Vessel: "MV GRXXX",
    Location: " At Port of Colombo, Sri Lanka",
    Link: "https://www.facebook.com/share/p/19avutXXPM/",
    completed: true,
    mainImages: [OME],
    additionalImages: [
      require('../assets/OME1.jpg'),
      require('../assets/OME2.jpg'),
      require('../assets/OME3.jpg'),
      require('../assets/OME4.jpg'),

    ],



  },
  {
    id: " 2",
    title: "A critical ramp pin dislodged on a RO-RO vessel, causing a complete interruption in cargo unloading.",
    project: "Conducted a quick and thorough structural assessment Re-located and reinstalled the detached ramp pin Ensured proper alignment and reinforced locking mechanisms Verified the ramp's operational safety with functional tests",
    description: "All repairs were carried out on-site with swift turnaround, restoring full ramp functionality and enabling the vessel to safely and efficiently resume operations.",
    Vessel: "MV GRXXX",
    Location: " At Port of Colombo, Sri Lanka",
    completed: true,
    mainImages: [RORO],
    additionalImages: [
      require('../assets/RORO1.jpg'),
      require('../assets/RORO2.jpg'),
      require('../assets/RORO3.jpg'),


    ],
    Link: "https://www.facebook.com/share/p/15fCQP4GBL/",


  },
  {
    id: " 3",
    title: "Servicing & Repairing of Ballast Pump & Motor",
    project: "Keeping vessels steady and safe at sea starts with reliable ballast systems",
    description: "Our expert team recently carried out servicing and repair of a ballast pump & motor, ensuring smooth operations, improved efficiency and extended equipment life. Precision inspection Overhauling & repairs Testing & commissioning 'TeamCIAP', we deliver dependable Total Marine & Engineering Solutions that minimise downtime and keep your voyage on course.",
    completed: true,
    mainImages: [pump],
    additionalImages: [
      require('../assets/pump&motor1.jpeg'),
      require('../assets/pump&motor2.jpeg'),
      require('../assets/pump&motor3.jpeg'),


    ],
    Link: "https://www.facebook.com/share/p/19ZnBxgjxA/",


  },
  {
    id: " 4",
    title: "'Team CIAP' – Ensuring Zero-Deficiency Inspections",
    project: "Our expert team supported the vessel in preparation for a successful Port State Control Inspection, helping it clear with zero deficiencies and zero observations.",
    description: "Key Jobs Completed: 1.Main Engine & Auxiliary Engine Insulation renewal 2.Sea Water (S.W.) Valve Replacement for reliable operations With precision workmanship and strict adherence to international standards, 'Team CIAP' ensures that vessels remain inspection-ready, safe and efficient.",
    completed: true,
    mainImages: [seawater],
    additionalImages: [
      require('../assets/seawater1.jpeg'),
      require('../assets/seawater2.jpeg'),
      require('../assets/seawater3.jpeg')


    ],
    Link: "https://www.facebook.com/share/p/19rsLvUo2d/",

  },




];

export default projects;
